/**
 * cashbook
 */

export const taxationOptions = [
  { text: "Standard Tax", value: "normal" },
  { text: "Reduced Tax", value: "reduced" },
  { text: "Tax Exempt", value: "none" },
];
